import EXIF from "exif-js";

export class ImageScaler {
  callback: $TSFixMe;

  canvas: $TSFixMe;

  context: $TSFixMe;

  image: $TSFixMe;

  maxSize: $TSFixMe;

  mimeType: $TSFixMe;

  orientation: $TSFixMe;

  quality: $TSFixMe;

  constructor() {
    this.canvas = document.createElement("canvas");
    this.context = this.canvas.getContext("2d");
    this.image = document.createElement("img");
    this.image.addEventListener("load", this.imageLoaded.bind(this), false);
  }

  static calculateScaledSize(
    width: $TSFixMe,
    height: $TSFixMe,
    maxSize: $TSFixMe,
    callback: $TSFixMe,
  ) {
    if (height > maxSize || width > maxSize) {
      let scaleFactor = 1;
      if (width > height) {
        scaleFactor = maxSize / width;
      } else {
        scaleFactor = maxSize / height;
      }
      callback(width * scaleFactor, height * scaleFactor);
    } else {
      callback(width, height);
    }
  }

  imageLoaded() {
    ImageScaler.calculateScaledSize(
      this.image.naturalWidth,
      this.image.naturalHeight,
      this.maxSize,
      (width: $TSFixMe, height: $TSFixMe) => {
        this.canvas.width = width;
        this.canvas.height = height;
        this.context.drawImage(this.image, 0, 0, width, height);

        this.callback(this.canvas.toDataURL(this.mimeType, this.quality));
      },
    );
  }

  scaleImage(
    image: $TSFixMe,
    maxSize: $TSFixMe,
    mimeType: $TSFixMe,
    quality: $TSFixMe,
    orientation: $TSFixMe,
    callback: $TSFixMe,
  ) {
    this.orientation = orientation;
    this.maxSize = maxSize;
    this.mimeType = mimeType;
    this.quality = quality;
    this.callback = callback;
    this.image.src = image;
  }

  extractImageOrientation(file: $TSFixMe, callback: $TSFixMe) {
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      const exif = EXIF.readFromBinaryFile(fileReader.result);
      callback(exif.Orientation);
    };
    fileReader.readAsArrayBuffer(file);
  }

  scaleImageFile(file: $TSFixMe, maxSize: $TSFixMe, quality: $TSFixMe) {
    if (file.type === "image/png" || file.type === "image/jpeg") {
      return new Promise((resolve) => {
        this.extractImageOrientation(file, (orientation: $TSFixMe) => {
          this.scaleImage(
            file.preview,
            maxSize,
            file.type,
            quality,
            orientation,
            (scaledImage: $TSFixMe) => {
              const byteString = atob(scaledImage.split(",")[1]);
              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              let i = 0;
              for (; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i);
              }
              resolve(new File([new Blob([ia])], file.name));
            },
          );
        });
      });
    }
    return new Promise((resolve) => resolve(file));
  }
}

export function scaleImageFile(
  file: $TSFixMe,
  maxSize: $TSFixMe,
  quality: $TSFixMe,
) {
  const imageScaler = new ImageScaler();
  return imageScaler.scaleImageFile(file, maxSize, quality);
}

export function isLcmApiUrl(imageUrl: string, lcmApiUrl: string) {
  try {
    const parsedImageUrl = new URL(imageUrl);
    const parsedLcmApiUrl = new URL(lcmApiUrl);

    return parsedImageUrl.origin === parsedLcmApiUrl.origin;
  } catch {
    return false;
  }
}

export function addAccessTokenToLcmApiUrl(
  imageUrl?: string,
  lcmApiUrl?: string,
  accessToken?: string,
) {
  if (!imageUrl || !lcmApiUrl || !accessToken) {
    return imageUrl;
  }

  if (!isLcmApiUrl(imageUrl, lcmApiUrl)) {
    return imageUrl;
  }

  const parsedImageUrl = new URL(imageUrl);
  parsedImageUrl.searchParams.set("access_token", accessToken);
  return parsedImageUrl.toString();
}
